import React from 'react';

const AdvertiserDetailContext = React.createContext();

export default AdvertiserDetailContext;
